import { fetchRest, getApiBaseUrl } from "@/config/api";

export interface MelStaticDataPayload {
  updatedAt: string | null;
  collections: string[];
  allCaracs: string[];
  caracsByCategory: Array<{ id_categorie: number; libelle: string }>;
  compositions: string[];
  couleurs: Array<{ id_couleur: number; couleur_FR: string; couleur_EN: string }>;
  categoriesFlat: Array<{ id_categorie: number; id_parent_categorie: string; label: string }>;
}

/** Récupère les données du template MEL depuis le cache serveur (endpoint public). */
export async function getMelTemplateData(): Promise<MelStaticDataPayload> {
  const res = await fetchRest(`${getApiBaseUrl()}/api/mel-template-data`, {
    method: "GET",
    skipAuthRedirect: true,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

/**
 * Transforme le payload en structures utilisées par downloadExcelTemplate.
 * Reconstruit aussi l'arbre Catégorie × Caracs (staticMemoCaracDetailedRows).
 */
export function buildMelDataFromPayload(p: MelStaticDataPayload) {
  // Map id_categorie → caracs
  const caracMap = new Map<number, string[]>();
  for (const { id_categorie, libelle } of p.caracsByCategory) {
    if (!caracMap.has(id_categorie)) caracMap.set(id_categorie, []);
    caracMap.get(id_categorie)!.push(libelle);
  }

  const childrenOf = (parentId: number) =>
    p.categoriesFlat.filter((c) => Number(c.id_parent_categorie) === parentId);

  const detailedRows: string[][] = [];
  for (const l1 of childrenOf(0)) {
    for (const l2 of childrenOf(l1.id_categorie)) {
      for (const l3 of childrenOf(l2.id_categorie)) {
        const caracs = caracMap.get(l3.id_categorie) ?? [];
        detailedRows.push([l1.label, l2.label, l3.label, ...caracs]);
      }
    }
  }

  return {
    staticCollectionsLibelles: p.collections,
    staticMemoCaracFlatLibelles: p.allCaracs,
    staticMemoCaracDetailedRows: detailedRows,
    staticCompositionLibelles: p.compositions,
    staticCouleursDefaut: p.couleurs,
  };
}
